import { createFileRoute } from "@tanstack/react-router"

import { PageContent } from "@/components/common/page-content"
import { PageHeader } from "@/components/common/page-header"
import { SubjectReviews } from "@/features/reviews/components/subject-reviews"
import { reviewQueries } from "@/queries/reviews"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/firms/$firmId/reviews/"
)({
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(
      reviewQueries.list({ firm_id: params.firmId })
    ),
  component: FirmReviewsPage,
})

/** The firm's reviews and its people's, together. */
function FirmReviewsPage() {
  const { firmId } = Route.useParams()

  return (
    <>
      <PageHeader title="Reviews" />
      <PageContent>
        <SubjectReviews filters={{ firm_id: firmId }} showSubject />
      </PageContent>
    </>
  )
}
